var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgReportAnalysis = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 120,
    viewBox: "0 0 128 120",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M42.0804 118.639C55.8057 125.71 71.0155 129.417 86.4552 129.453C92.2097 129.453 98.0464 128.935 103.447 126.948C117.375 121.806 126.564 106.157 124.278 91.4879C123.469 86.2846 121.39 81.2387 121.522 75.9746C121.662 70.4349 124.224 65.296 125.852 60.0032C127.676 54.0572 128.338 47.816 127.803 41.6198C126.997 32.3512 123.15 22.9466 115.657 17.4176C112.647 15.1917 109.183 13.678 105.751 12.1821L89.973 5.28255C80.6686 1.22439 69.5427 -2.74787 60.8896 2.55564C53.0489 7.36172 50.6727 17.9437 43.4832 23.6695C34.5581 30.7909 19.5709 29.4633 13.7413 39.2758C8.88155 47.4637 13.7914 58.3284 10.6601 67.3179C9.61517 70.3132 7.73281 72.922 6.03297 75.5988C0.54337 84.2841 -5.25399 103.197 8.5058 107.867C12.589 109.252 17.4523 108.204 21.6894 109.156C29.0542 110.809 35.4635 115.225 42.0804 118.639Z",
    fill: "#0062FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1975 98.3869C11.1975 98.3869 20.7918 95.6027 19.7576 86.5274C18.7233 77.452 21.0316 60.7613 26.4281 61.1192C31.8247 61.477 58.8468 61.1192 58.8468 61.1192V81.7785H41.1076C41.1076 81.7785 42.3458 88.6853 39.1465 93.5343C35.9472 98.3833 34.3011 97.6605 34.3011 97.6605L11.1975 98.3869Z",
    fill: "#0062FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1975 98.3869C11.1975 98.3869 20.7918 95.6027 19.7576 86.5274C18.7233 77.452 21.0316 60.7613 26.4281 61.1192C31.8247 61.477 58.8468 61.1192 58.8468 61.1192V81.7785H41.1076C41.1076 81.7785 42.3458 88.6853 39.1465 93.5343C35.9472 98.3833 34.3011 97.6605 34.3011 97.6605L11.1975 98.3869Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8328 53.733H94.7225C94.7225 53.733 99.4642 54.8674 99.9795 61.1586V117.364L68.1119 117.88C67.8072 117.904 67.5012 117.91 67.1958 117.898C64.6641 117.795 62.2709 116.715 60.5191 114.884C58.7673 113.054 57.7933 110.615 57.8019 108.081V59.5089C57.8019 59.5089 57.1971 54.4559 51.8328 53.733Z",
    fill: "#0062FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8328 53.733H94.7225C94.7225 53.733 99.4642 54.8674 99.9795 61.1586V117.364L68.1119 117.88C67.7402 117.908 67.367 117.908 66.9954 117.88C64.5014 117.732 62.1589 116.634 60.4491 114.812C58.7393 112.991 57.792 110.583 57.8019 108.085V59.5089C57.8019 59.5089 57.1971 54.4559 51.8328 53.733Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0873 104.095C70.0873 104.095 65.1775 103.608 65.1274 110.268C65.0773 116.928 69.5362 115.636 69.5362 115.636L70.481 115.582C70.481 115.582 76.4143 111.488 73.2115 106.972C73.2115 106.961 71.8981 104.324 70.0873 104.095Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6133 105.04C70.6133 105.04 66.1973 104.592 66.1508 110.594C66.1043 116.595 70.1195 115.418 70.1195 115.418L70.9676 115.371C70.9676 115.371 76.3069 111.685 73.4261 107.62C73.4261 107.602 72.2416 105.233 70.6133 105.04Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0873 104.095H111.9C111.9 104.095 114.96 105.193 114.652 110.25C114.344 115.307 108.98 117.88 108.98 117.88H68.1262C68.1262 117.88 72.2524 115.457 72.306 110.722C72.3597 105.988 70.0873 104.095 70.0873 104.095Z",
    fill: "#0062FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0873 104.095H111.9C111.9 104.095 114.96 105.193 114.652 110.25C114.344 115.307 108.98 117.88 108.98 117.88H68.1262C68.1262 117.88 72.2524 115.457 72.306 110.722C72.3597 105.988 70.0873 104.095 70.0873 104.095Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.428 61.1228C26.428 61.1228 29.3839 61.3984 29.1084 66.004C28.8328 70.6097 28.4213 82.0255 33.9216 82.0255C39.4219 82.0255 43.1365 81.1309 43.3405 77.9674C43.5445 74.8039 43.6984 60.9188 43.6984 60.9188L26.428 61.1228Z",
    fill: "#0062FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8328 53.7329C51.8328 53.7329 44.3177 53.4932 43.6843 60.9188C43.0509 68.3444 43.3264 77.9673 43.3264 77.9673C43.3264 77.9673 42.2278 81.9038 36.4519 82.0935H57.8628L57.8306 59.5088C57.8306 59.5088 57.0576 54.3163 51.8328 53.7329Z",
    fill: "#0062FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8328 53.7329C51.8328 53.7329 44.3177 53.4932 43.6843 60.9188C43.0509 68.3444 43.3264 77.9673 43.3264 77.9673C43.3264 77.9673 42.2278 81.9038 36.4519 82.0935H57.8628L57.8306 59.5088C57.8306 59.5088 57.0576 54.3163 51.8328 53.7329Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2359 14.9765C69.7723 15.3344 68.8203 16.8231 68.5412 18.3046C68.2621 19.7862 68.509 21.3071 68.6378 22.8101C68.7738 24.4241 68.7667 26.0309 68.7774 27.6663C68.7774 28.382 68.7953 29.1514 69.1567 29.7813C69.6148 30.5757 70.5273 30.9908 71.4184 31.2127C72.8892 31.5706 74.4209 31.5062 75.9311 31.4417C76.5215 31.4167 77.1585 31.3737 77.6023 30.9873C77.9215 30.6697 78.1374 30.263 78.2214 29.8206C78.4799 28.6875 78.6131 27.5295 78.6186 26.3673L78.8763 20.7023C78.9693 18.684 78.8977 16.0036 76.7291 15.0123C76.11 14.7296 75.4301 14.8226 74.7716 14.8477C73.6372 14.8906 72.3668 14.6867 71.2359 14.9765Z",
    fill: "#0062FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0571 28.4285C70.6098 28.7864 71.0571 30.0174 71.7728 30.2178C72.2094 30.3359 69.6256 30.386 69.3537 30.021C69.0491 29.5889 68.8595 29.0865 68.8026 28.5609C68.7381 26.9613 68.9135 25.3402 68.8491 23.7227C68.7813 23.0164 68.8334 22.3038 69.003 21.6148C69.3215 20.5663 70.1517 19.7575 70.599 18.752C71.0893 19.3353 71.0249 20.1834 70.9784 20.9492C70.9106 22.0934 70.9526 23.2414 71.1036 24.3775C71.1321 24.7256 71.218 25.0666 71.3577 25.3867C71.805 26.3064 73.147 26.5354 73.419 27.5339C73.7625 28.815 71.7943 28.654 71.0571 28.4285Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4082 15.499L73.6802 16.1825C73.7947 16.4688 73.9558 16.7909 74.2564 16.8553C74.4127 16.8726 74.5708 16.8479 74.7144 16.7837C75.062 16.6778 75.3562 16.4437 75.5375 16.1288C75.6266 15.9014 75.6609 15.6562 75.6377 15.4131C75.6091 14.5471 75.5196 11.3371 74.2492 11.4981C73.2293 11.6377 73.1184 14.7761 73.4082 15.499Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5246 15.5133C74.7357 15.7423 75.0614 15.9463 75.3405 15.8103C75.6197 15.6743 75.6698 15.3666 75.6984 15.0946C75.727 14.8226 75.7449 14.5507 75.7485 14.2787C75.7649 14.1454 75.7352 14.0106 75.6642 13.8966C75.5932 13.7826 75.4853 13.6964 75.3584 13.6524C75.0471 13.4556 73.7624 12.6254 73.7373 13.4878C73.745 14.2362 74.0249 14.9562 74.5246 15.5133Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2249 9.49049C78.0546 10.4852 77.8154 11.4669 77.5092 12.4285C77.3914 12.8498 77.2169 13.2531 76.9903 13.6274C76.7597 14.0021 76.4052 14.2845 75.9883 14.4254C75.7107 14.4888 75.4225 14.4895 75.1446 14.4276C74.8666 14.3657 74.606 14.2427 74.3815 14.0675C73.9602 13.7687 73.6285 13.3603 73.4224 12.8866C73.2703 12.512 73.1774 12.116 73.1469 11.7128C73.024 10.6543 73.2105 9.58284 73.6837 8.62805C73.8382 8.31144 74.0562 8.03004 74.3243 7.80139C74.5885 7.60669 74.8906 7.46949 75.2111 7.39861C75.5316 7.32773 75.8634 7.32474 76.1851 7.38985C76.8276 7.52251 77.4426 7.76461 78.0031 8.10557C78.5041 8.39186 78.3073 9.0217 78.2249 9.49049Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.132 6.83155C78.3148 6.98139 78.4782 7.15328 78.6187 7.34329L79.3702 8.27373C79.4859 8.39216 79.5654 8.54114 79.5993 8.70316C79.6058 8.84628 79.567 8.98781 79.4883 9.10755C79.3629 9.31168 79.1908 9.48306 78.986 9.60751C78.7813 9.73196 78.5499 9.80592 78.311 9.82327C77.7647 9.80809 77.2328 9.64482 76.7722 9.35089C76.7023 9.45017 76.6042 9.52613 76.4906 9.56889C76.377 9.61165 76.2531 9.61924 76.1352 9.59066C75.8954 9.5513 75.6735 9.44036 75.4194 9.40815C75.2084 9.38613 74.9954 9.42137 74.8027 9.51016C74.61 9.59895 74.4448 9.73802 74.3244 9.91274C74.2564 10.0129 74.1383 10.1418 74.0453 10.063C74.0279 10.047 74.0139 10.0276 74.0041 10.0061C73.9943 9.98464 73.9888 9.96141 73.988 9.93779C73.9486 9.73738 73.8449 9.49046 73.6301 9.5012C73.5642 9.51049 73.5034 9.54165 73.4573 9.58967C73.4112 9.63769 73.3826 9.69979 73.3761 9.76601C73.3684 9.89741 73.3879 10.029 73.4333 10.1525L73.6087 10.7215C73.614 10.7439 73.614 10.7671 73.6087 10.7895C73.6087 10.8503 73.5049 10.8468 73.4405 10.8539C73.2973 10.8539 73.2079 11.015 73.1649 11.1509C73.1375 11.2932 73.0788 11.4277 72.9931 11.5446C72.9776 11.5607 72.9577 11.5719 72.9359 11.5768C72.912 11.574 72.8895 11.564 72.8715 11.5482C72.7674 11.4395 72.6865 11.3108 72.6336 11.1699C72.5807 11.0291 72.557 10.879 72.5637 10.7287C72.5279 10.2921 72.5029 9.8519 72.485 9.41173C72.447 9.06589 72.4824 8.71593 72.5888 8.38467C72.7042 8.12664 72.8547 7.88579 73.0361 7.66894C73.1967 7.42702 73.3893 7.20793 73.6087 7.01763C73.9511 6.78272 74.3476 6.63865 74.761 6.59894C75.3644 6.49118 75.9768 6.44204 76.5897 6.45221C77.1307 6.41575 77.6697 6.5483 78.132 6.83155Z",
    fill: "#3E3E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6548 18.8915C81.1164 20.323 81.1021 21.8725 81.0771 23.3863C81.0814 23.9445 81.0407 24.5022 80.9554 25.0539C80.884 25.5199 80.7038 25.9625 80.4293 26.3458C80.2915 26.5362 80.1151 26.6955 79.9116 26.8133C79.7082 26.931 79.4822 27.0046 79.2484 27.0293C79.056 27.0446 78.8632 27.0036 78.6937 26.9112C78.2607 26.6571 78.1963 26.0702 78.1784 25.5692L77.9708 19.6788C77.9386 18.7806 76.296 16.272 76.4535 15.3845C76.6253 14.4218 78.7832 16.1217 79.2985 16.6298C79.9252 17.2643 80.3903 18.0399 80.6548 18.8915Z",
    fill: "#0062FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4616 20.7846C80.4616 20.6522 80.4616 20.4876 80.3435 20.4267C80.3066 20.4118 80.2665 20.4066 80.227 20.4116C80.1876 20.4167 80.15 20.4317 80.118 20.4554C80.045 20.5237 79.9876 20.6071 79.9499 20.6998C79.9122 20.7924 79.8951 20.8922 79.8997 20.9922C79.8604 21.418 79.8174 21.8439 79.7781 22.2697C79.7566 22.5202 79.6099 22.964 79.9928 22.8996C80.5475 22.8065 80.433 21.1997 80.4616 20.7846Z",
    fill: "#3E3E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4705 22.2304C79.2835 22.2516 79.1038 22.3152 78.945 22.4162C78.7863 22.5173 78.6527 22.6532 78.5543 22.8137C78.5418 22.8362 78.5321 22.8603 78.5257 22.8853C78.5247 22.9186 78.5347 22.9513 78.5543 22.9783C78.6133 23.0511 78.6874 23.1102 78.7714 23.1516C78.8554 23.193 78.9474 23.2157 79.041 23.2181C79.4491 23.2843 79.8624 23.3131 80.2757 23.304C80.3607 23.3094 80.4454 23.2895 80.519 23.2467C80.5829 23.1891 80.6268 23.1127 80.6443 23.0284C80.723 22.7708 80.8769 22.2698 80.5405 22.1982C80.3667 22.2006 80.1934 22.215 80.0216 22.2411C79.8382 22.2268 79.6542 22.2232 79.4705 22.2304Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2366 20.2264C65.6283 21.0137 64.9877 21.9262 65.1416 22.9067C65.2695 23.4844 65.5733 24.0082 66.0112 24.4062C67.3746 25.8054 69.2677 26.5176 71.1 27.1903C71.1771 27.23 71.2649 27.2438 71.3505 27.2297C71.4228 27.2059 71.4863 27.161 71.533 27.1009C72.127 26.4031 71.6976 25.3116 71.0499 24.6495C70.4021 23.9875 69.5469 23.5258 69.1282 22.7099C69.0808 22.6366 69.0583 22.5501 69.0637 22.463C69.0935 22.3646 69.1536 22.2782 69.2355 22.2161C70.2554 21.2892 71.1894 20.1619 71.4507 18.8092C71.6189 17.9289 71.1179 15.0481 69.7115 15.8497C69.0351 16.2326 68.4947 17.3026 68.0259 17.911L66.2366 20.2264Z",
    fill: "#0062FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.053 31.3916L70.9282 52.2729L68.4805 53.6148L73.1327 53.3787L73.6838 35.8434L75.5805 35.7611L77.0835 53.5433L81.9039 53.8582L79.3738 52.0438L79.5062 30.2143L69.6328 30.1892C69.053 30.1964 68.9994 30.8047 69.053 31.3916Z",
    fill: "#3E3E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1867 23.2574C75.2565 23.0506 75.4005 22.8769 75.5908 22.7698C75.7811 22.6628 76.0043 22.63 76.2173 22.6777C78.0162 22.6777 79.815 22.7504 81.6139 22.896C81.8473 22.8865 82.0754 22.9672 82.2509 23.1214C82.3263 23.252 82.3675 23.3996 82.3706 23.5504C82.3738 23.7011 82.3387 23.8503 82.2688 23.9839C81.4972 26.1232 80.5776 28.2062 79.5168 30.2178C79.4823 30.2985 79.4339 30.3724 79.3737 30.4361C79.2176 30.5561 79.0223 30.6135 78.8261 30.5972C76.7111 30.6754 74.5933 30.6228 72.4848 30.4397C72.3632 30.4397 72.2164 30.4039 72.1663 30.2894C72.0482 30.021 72.6315 29.2158 72.7461 28.9152C72.9823 28.2925 73.2041 27.6627 73.4618 27.0436C73.9664 25.7589 74.5497 24.492 75.1867 23.2574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8141 25.3223C73.1004 25.2614 73.4762 25.2614 73.5907 25.5298C73.6587 25.6909 73.6086 25.9163 73.7553 26.013C73.8121 26.0441 73.8768 26.0578 73.9414 26.0523C74.1704 26.0523 74.3959 25.9986 74.6213 26.0094C74.7351 26.0047 74.8482 26.0288 74.9502 26.0795C75.0521 26.1301 75.1397 26.2057 75.2046 26.2992C75.253 26.4148 75.2724 26.5404 75.2611 26.6651C75.2499 26.7898 75.2084 26.9099 75.1402 27.015C75.0347 27.2271 74.8984 27.4224 74.7358 27.5947C74.6104 27.7344 74.4583 27.8475 74.2885 27.9275C74.1316 27.9923 73.9644 28.0287 73.7947 28.0349C73.0816 28.0935 72.367 27.9403 71.7405 27.5947C71.3754 27.4258 71.086 27.1274 70.9282 26.7573C70.5345 25.63 72.102 25.4654 72.8141 25.3223Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4253 60.4357H67.6107C67.0415 60.4357 66.5801 60.8971 66.5801 61.4663C66.5801 62.0355 67.0415 62.497 67.6107 62.497H94.4253C94.9945 62.497 95.4559 62.0355 95.4559 61.4663C95.4559 60.8971 94.9945 60.4357 94.4253 60.4357Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4253 64.9734H67.6107C67.0415 64.9734 66.5801 65.4348 66.5801 66.004C66.5801 66.5732 67.0415 67.0347 67.6107 67.0347H94.4253C94.9945 67.0347 95.4559 66.5732 95.4559 66.004C95.4559 65.4348 94.9945 64.9734 94.4253 64.9734Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4253 69.511H67.6107C67.0415 69.511 66.5801 69.9725 66.5801 70.5417C66.5801 71.1109 67.0415 71.5723 67.6107 71.5723H94.4253C94.9945 71.5723 95.4559 71.1109 95.4559 70.5417C95.4559 69.9725 94.9945 69.511 94.4253 69.511Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4253 74.0488H67.6107C67.0415 74.0488 66.5801 74.5102 66.5801 75.0794C66.5801 75.6486 67.0415 76.11 67.6107 76.11H94.4253C94.9945 76.11 95.4559 75.6486 95.4559 75.0794C95.4559 74.5102 94.9945 74.0488 94.4253 74.0488Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4253 78.5864H67.6107C67.0415 78.5864 66.5801 79.0479 66.5801 79.6171C66.5801 80.1863 67.0415 80.6477 67.6107 80.6477H94.4253C94.9945 80.6477 95.4559 80.1863 95.4559 79.6171C95.4559 79.0479 94.9945 78.5864 94.4253 78.5864Z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4253 83.1241H67.6107C67.0415 83.1241 66.5801 83.5856 66.5801 84.1548C66.5801 84.724 67.0415 85.1854 67.6107 85.1854H94.4253C94.9945 85.1854 95.4559 84.724 95.4559 84.1548C95.4559 83.5856 94.9945 83.1241 94.4253 83.1241Z",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4253 87.6618H67.6107C67.0415 87.6618 66.5801 88.1232 66.5801 88.6924C66.5801 89.2617 67.0415 89.7231 67.6107 89.7231H94.4253C94.9945 89.7231 95.4559 89.2617 95.4559 88.6924C95.4559 88.1232 94.9945 87.6618 94.4253 87.6618Z",
    fill: "url(#paint18_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5636 92.2675H69.4001V101.618H72.5636V92.2675Z",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9653 95.1233H73.8018V101.618H76.9653V95.1233Z",
    fill: "url(#paint20_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5575 92.6755H82.394V101.618H85.5575V92.6755Z",
    fill: "url(#paint21_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2956 97.4922H78.1321V101.618H81.2956V97.4922Z",
    fill: "url(#paint22_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5682 94.5149H88.8572V101.686H92.5682V94.5149Z",
    fill: "url(#paint23_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2828 94.5328H92.5718V101.69H96.2828V94.5328Z",
    fill: "url(#paint24_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2828 92.543H88.8572V94.4683H96.2828V92.543Z",
    fill: "url(#paint25_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1167 110.293C58.3422 111.592 60.0599 116.151 64.365 117.278C66.3475 117.797 68.6593 118.302 70.556 117.525C71.1236 117.311 71.6404 116.981 72.0733 116.556C72.5703 115.997 72.8493 115.278 72.8592 114.531C72.869 113.784 72.6091 113.058 72.127 112.487C71.7058 112.067 71.2231 111.713 70.6955 111.438C69.171 110.547 67.3102 109.087 65.4743 109.044C63.6385 109.001 59.8559 109.692 58.1167 110.293Z",
    fill: "url(#paint26_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11.1975,
    y1: 79.7531,
    x2: 58.8468,
    y2: 79.7531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 51.8399,
    y1: 85.4467,
    x2: 126.508,
    y2: 86.3914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 2866.71,
    y1: 4353.15,
    x2: 1458,
    y2: 3490.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 2544.62,
    y1: 3879.26,
    x2: 1404.25,
    y2: 3180.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 14799.4,
    y1: 3820.49,
    x2: 14645.4,
    y2: 5391.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 3231.17,
    y1: 5506.22,
    x2: 4510.47,
    y2: 5506.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 1234.8,
    y1: 827.808,
    x2: 1118.06,
    y2: 840.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 73.2687,
    y1: 14.1856,
    x2: 75.6377,
    y2: 14.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 590.778,
    y1: 147.172,
    x2: 587.893,
    y2: 103.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 1387.31,
    y1: 242.645,
    x2: 1463.41,
    y2: 242.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 671.476,
    y1: 95.3438,
    x2: 685.28,
    y2: 95.3438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 1149.95,
    y1: 237.579,
    x2: 1204.05,
    y2: 237.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 6656.63,
    y1: 375.296,
    x2: 6654.8,
    y2: 643.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 6691.28,
    y1: 380.082,
    x2: 6689.45,
    y2: 648.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 6725.93,
    y1: 384.846,
    x2: 6724.1,
    y2: 653.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 6760.58,
    y1: 389.631,
    x2: 6758.75,
    y2: 657.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 6795.23,
    y1: 394.395,
    x2: 6793.4,
    y2: 662.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 6829.88,
    y1: 399.181,
    x2: 6828.06,
    y2: 667.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 6864.54,
    y1: 403.945,
    x2: 6862.71,
    y2: 672.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 701.057,
    y1: 2423.64,
    x2: 661.828,
    y2: 2641.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 745.002,
    y1: 1719.51,
    x2: 725.633,
    y2: 1873.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 828.6,
    y1: 2342.28,
    x2: 792.624,
    y2: 2550.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 788.116,
    y1: 1132.49,
    x2: 780.225,
    y2: 1230.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 1029.05,
    y1: 1944.56,
    x2: 1033.07,
    y2: 2180.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 1071.65,
    y1: 1968.01,
    x2: 1073.72,
    y2: 2372.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 2005.63,
    y1: 581.415,
    x2: 2006.3,
    y2: 615.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 3597.7,
    y1: 2741.14,
    x2: 3339.53,
    y2: 3670.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 129.453,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReportAnalysis, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/report_analysis.cc4dea53.svg";
export { ForwardRef as ReactComponent };